//
// Module for the Permissions page in the Security section
//
rs.module("ui/security/administration/permissions",

    ["ui/framework/client-templates", "controls/components/event-banner"],

    function (clientTemplates, eventBanner) {

        var _securityModelControl;
        var _trusteesGrid;
        var _saveButton;
        var _saveSpinner;

        //
        // Initialize the module
        //
        function initialize(jsSelectors, backendUrls, trusteesAndPermissionLoadingTemplateKey, securityModelControl) {

            _securityModelControl = securityModelControl;
            var form = $.js(jsSelectors.form);

            var scrollContainer = form.js(jsSelectors.scrollContainer);
            var scrollTopHidden = form.js(jsSelectors.scrollTopHidden);
            var scrollLeftHidden = form.js(jsSelectors.scrollLeftHidden);

            // Scroll the security model container vertically to the position it was before a post and ensure selected node is visible
            var scrollTopPosition = scrollTopHidden.val();

            var nodeDOMRect = securityModelControl.getSelectedNodeDOM()[0].getBoundingClientRect();
            var scrollContainerDOMRect = scrollContainer[0].getBoundingClientRect();

            // Calcluate the position of the node as if the container was scrolled
            // At this point we havent scrolled the container, so nodeDOMRect.top is going to give us the nodes position like the container was scrolled to 0.
            // We need to adjust that for the previous scroll position.
            var nodeTopPosition = nodeDOMRect.top - scrollTopPosition;
            var nodeBottomPosition = nodeDOMRect.bottom - scrollTopPosition;

            // Check if the node is off screen vertically, if so adjust the scroll position
            if (nodeTopPosition < scrollContainerDOMRect.top) {

                scrollTopPosition = scrollTopPosition - (scrollContainerDOMRect.top - nodeTopPosition);

            } else if (nodeBottomPosition > scrollContainerDOMRect.bottom) {

                scrollTopPosition = scrollTopPosition - (scrollContainerDOMRect.bottom - nodeBottomPosition);
            }

            // scroll the container and save the new scroll position
            scrollContainer.animate({ scrollTop: scrollTopPosition });
            scrollTopHidden.val(scrollTopPosition);

            // Scroll the security model container horizontally to the position it was before a post
            if (scrollLeftHidden.val()) {
                scrollContainer.scrollLeft(scrollLeftHidden.val());
            }

            // Hook up scroll evet to save off the scroll position so that we can scroll to it after a post
            scrollContainer.scroll(_.debounce(function () {
                scrollTopHidden.val(scrollContainer.scrollTop());
                scrollLeftHidden.val(scrollContainer.scrollLeft());
            }, 200));

            // reload the security model when a new site is selected
            form.js(jsSelectors.siteSelect).change(function () {

                form.js(jsSelectors.loadingSpinner).show();
                eventBanner.removeAllMessages();

                securityModelControl.loadSecurityModel($(this).val()).always(function () {
                    form.js(jsSelectors.loadingSpinner).hide();
                });
            });

            securityModelControl.onNodeSelected(function (resourcePath) {

                eventBanner.removeAllMessages();

                form.js(jsSelectors.trusteesAndPermissionsContainer).html(clientTemplates.render(trusteesAndPermissionLoadingTemplateKey));

                $.get(backendUrls.loadTrusteesAndPermissions,
                {
                    siteSecurityId: form.js(jsSelectors.siteSelect).val(),
                    resourcePath: resourcePath,
                    selectedTrusteeName: _trusteesGrid.selectedValues.length > 0 ? _trusteesGrid.selectedValues[0] : null

                }).done(function (results) {
                    form.js(jsSelectors.trusteesAndPermissionsContainer).html(results);
                })
            });

            // Hook up submit event so that we can disabled the save button and show a spinner
            form.submit(function () {
                _saveButton.setDisabled();
                _saveSpinner.show();
            });
        }

        //
        // Initailize the Trustees partial view
        //
        function initializeTrustees(jsSelectors, backendUrls, permissionLoadingTemplateKey, selectedSiteSecurityId, trusteesGrid) {

            // save off the grid api so it is available to the whole module
            _trusteesGrid = trusteesGrid;

            var executeSelectionChanged = false;

            // load permissions when a trustee is selected
            trusteesGrid.selectionChanged(function (values, rows) {

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (executeSelectionChanged && values.length > 0) {

                    // Remove errors and show the loading skeleton
                    eventBanner.removeAllMessages();
                    $.js(jsSelectors.permissionsContainer).html(clientTemplates.render(permissionLoadingTemplateKey));

                    // load permissions
                    $.get(
                        backendUrls.loadPermissions,
                        {
                            resourcePath: _securityModelControl.getSelectedNodeResourcePath(),
                            selectedTrusteeName: values[0],
                            siteSecurityId: selectedSiteSecurityId
                        },
                        function (results) {

                            $.js(jsSelectors.permissionsContainer).html(results);
                        }
                    );
                }

                executeSelectionChanged = true;
            });
        }

        //
        // Initialize the Permissions partial view
        //
        function initializePermissions(jsSelectors, cssClasses) {

            // save off the save button and spinner so it is available to the whole module
            _saveButton = $.js(jsSelectors.saveButton);
            _saveSpinner = $.js(jsSelectors.saveSpinner);

            // Hook up change event for the Allow select all checkbox
            $.js(jsSelectors.allowAllCheckbox).click(function () {

                if (!$(this).hasClass(cssClasses.disabled)) {

                    eventBanner.removeAllMessages();

                    var checkAll = !($(this).hasClass(cssClasses.allSelected) || $(this).hasClass(cssClasses.someSelected));
                    $.js(jsSelectors.allowCheckbox, { multiple: true }).not(":disabled").setChecked(checkAll);

                    if (checkAll) {
                        $.js(jsSelectors.denyCheckbox, { multiple: true }).not(":disabled").setChecked(false);
                    }

                    _updateSelectAllCssClasses();
                } 
            });

            // Hook up change event for the Deny select all checkbox
            $.js(jsSelectors.denyAllCheckbox).click(function () {

                if (!$(this).hasClass(cssClasses.disabled)) {

                    eventBanner.removeAllMessages();

                    var checkAll = !($(this).hasClass(cssClasses.allSelected) || $(this).hasClass(cssClasses.someSelected));
                    $.js(jsSelectors.denyCheckbox, { multiple: true }).not(":disabled").setChecked(checkAll);

                    if (checkAll) {
                        $.js(jsSelectors.allowCheckbox, { multiple: true }).not(":disabled").setChecked(false);
                    }

                    _updateSelectAllCssClasses();
                }
            });

            // Hook up change event for the individual Allow checkboxes
            $.js(jsSelectors.allowCheckbox, { multiple: true }).change(function () {

                eventBanner.removeAllMessages();

                // If this checkbox is being checked, find the corresponding deny checkbox, and if its not disabled, uncheck it
                if ($(this).is(":checked")) {

                    var denyCheckbox = $(this).closest(`[data-js=${jsSelectors.accessRightRow}]`).find(`[data-js=${jsSelectors.denyCheckbox}]`);

                    if (!denyCheckbox.is(":disabled")) {
                        denyCheckbox.setChecked(false);
                    }
                }

                _updateSelectAllCssClasses();
            });

            // Hook up change event for the individual Deny checkboxes
            $.js(jsSelectors.denyCheckbox, { multiple: true }).change(function () {

                eventBanner.removeAllMessages();

                // If this checkbox is being checked, find the corresponding allow checkbox, and if its not disabled, uncheck it
                if ($(this).is(":checked")) {

                    var allowCheckbox = $(this).closest(`[data-js=${jsSelectors.accessRightRow}]`).find(`[data-js=${jsSelectors.allowCheckbox}]`);

                    if (!allowCheckbox.is(":disabled")) {
                        allowCheckbox.setChecked(false);
                    }
                }

                _updateSelectAllCssClasses();
            });

            // Helper function to update the css class on the Allow and Deny select all checkboxes based on whether none, some or all checkboxes are checked
            function _updateSelectAllCssClasses() {

                var allowCheckboxesCount = $.js(jsSelectors.allowCheckbox, { multiple: true }).not(":disabled").length;
                var allowCheckboxesCheckedCount = $.js(jsSelectors.allowCheckbox, { multiple: true }).not(":disabled").filter(":checked").length;

                var denyCheckboxesCount = $.js(jsSelectors.denyCheckbox, { multiple: true }).not(":disabled").length;
                var denyCheckboxesCheckedCount = $.js(jsSelectors.denyCheckbox, { multiple: true }).not(":disabled").filter(":checked").length;

                if (allowCheckboxesCheckedCount == 0) {

                    $.js(jsSelectors.allowAllCheckbox).removeClass(`${cssClasses.allSelected} ${cssClasses.someSelected}`);
                }
                else {

                    $.js(jsSelectors.allowAllCheckbox).addClass(allowCheckboxesCheckedCount == allowCheckboxesCount ? cssClasses.allSelected : cssClasses.someSelected);
                }
                
                if (denyCheckboxesCheckedCount == 0) {

                    $.js(jsSelectors.denyAllCheckbox).removeClass(`${cssClasses.allSelected} ${cssClasses.someSelected}`);
                }
                else {

                    $.js(jsSelectors.denyAllCheckbox).addClass(denyCheckboxesCheckedCount == denyCheckboxesCount ? cssClasses.allSelected : cssClasses.someSelected);
                }
            }
        }

        // Exported public API
        var exports = {
            initialize,
            initializeTrustees,
            initializePermissions
        };

        return exports;
    }
);